import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PageEvent as NgPageEvent } from '@angular/material/paginator';
import { environment } from 'src/environments/environment';
import { IEditListingConfig } from 'src/app/interfaces/edit-listing-config';
import { IListing } from 'src/app/interfaces/listing';
import { AuthService } from 'src/app/services/auth.service';
import { CarouselImageDataSource } from 'src/modules/carousel-image/services/carousel-image-data-source';
import { CategoryApiService } from 'src/modules/category/services/category-api-service';
import { CategoryDataSource } from 'src/modules/category/services/category-data-source';
import { CohortsApiService } from 'src/modules/cohorts/services/cohorts-api-service';
import { CohortsDataSource } from 'src/modules/cohorts/services/cohorts-data-source';
import { SearchText } from 'src/modules/directives/components/search/component';
import { AuditLog } from 'src/modules/listing/components/audit-log/component';
import { ListingApiService } from 'src/modules/listing/services/listing-api-service';
import { ListingDataSource } from 'src/modules/listing/services/listing-data-source';
import { ProductInfoApiService } from 'src/modules/product-info/services/product-info-api-service';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';
import { OrganisationAdminApiService } from 'src/modules/role/organisation-admin/services/organisation-admin-api-service';
import { ListingCarouselImageApiService } from '../../services/carousel-image-api-service';
import { ListingEdit } from 'src/modules/listing/components/edit/component';
import { ProductList } from '../../../../product/components/list/component';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganisationPicker } from 'src/modules/organisation/components/organisation-picker/component';
import { OrganisationDataSource } from 'src/modules/organisation/services/organisation-data-source';
import { TicketsList } from 'src/modules/ticket/components/list/component';
import { CategoriesList } from 'src/modules/category/components/list/component';
import { OffersList } from 'src/modules/local-offers/components/list/component';
import { BranchApiService } from '../../../../branch/services/branch-api-service';
import { BranchDataSource } from '../../../../branch/services/branch-data-source';
import { BranchEventPicker } from 'src/modules/branch/components/branch-picker/component';
import { Clipboard } from '@angular/cdk/clipboard';
import { RelatedContentList } from 'src/modules/related-content/components/list/component';
import { CohortsList } from 'src/modules/cohorts/components/list/component';
import md5 from 'md5';

@Component({
    selector: 'listing-admin-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ListingDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;
  @ViewChild('typeFilter', { static: false })
  public typeFilter: MatButtonToggleGroup;
  @ViewChild('statusFilter', { static: false })
  public statusFilter: MatButtonToggleGroup;
  public leisureUrl: string = environment.leisureUrl;
  public loading: boolean;
  public processListingId: number;
  public Listings: IListing[];
  public PageEvent: NgPageEvent;
  public isEventAdmin: boolean;
  public isOrgAdmin: boolean;
  public isAdmin: boolean;
  public isBranchAdmin: boolean;

  public isListingAdmin: boolean;

  public toggle: MatButtonToggleGroup;
  @ViewChild(SearchText, { static: false })
  private readonly SearchComponent: SearchText;
  public DataSource: ListingDataSource;
  private CarouselImageDataSource: CarouselImageDataSource;
  private CategoryDataSource: CategoryDataSource;
  private CohortsDataSource: CohortsDataSource;
  public BranchDataSource = new BranchDataSource(
    this.BranchApiService,
    'listing-admin'
  );
  private Subscriptions: RxSubscription[] = [];
  public userOrgs;
  public orgSelected;
  public catSelected;
  public toggleVal;
  public categories;
  public cohorts;
  public status = 'live';

  public typeOptions = [
    { type: 'listing', title: 'Listings', icon: 'bookmark' },
    { type: 'ticket', title: 'Tickets', icon: 'payment' },
    { type: 'product', title: 'Products', icon: 'shopping_cart' },
    { type: 'promoted_event', title: 'Promoted', icon: 'star_rate' },
  ];
  constructor(
    private ListingApi: ListingApiService,
    private ProductInfoApi: ProductInfoApiService,
    private CarouselImageApi: ListingCarouselImageApiService,
    private CategoryApi: CategoryApiService,
    private CohortsApi: CohortsApiService,
    private OrganisationAdminApi: OrganisationAdminApiService,
    private BranchApiService: BranchApiService,
    private Auth: AuthService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private clipboard: Clipboard
  ) {}

  async ngOnInit() {
    this.isEventAdmin = this.hasPermisson('event-admin');
    this.isOrgAdmin = this.hasPermisson('organisation-admin');
    this.isBranchAdmin = this.hasPermisson('branch-admin');

    this.isAdmin = this.Auth.inGroup('admin');
    this.status = this.isBranchAdmin ? 'null' : 'live';

    if (this.isAdmin) {
      const { data } = await this.CategoryApi.getAllCategories('admin');
      this.categories = data;
    }

    if (this.isOrgAdmin) {
      const { data } = await this.OrganisationAdminApi.getOrgs(
        this.Auth.user.id,
        {},
        null,
        'organisation-admin'
      );

      this.userOrgs = data;
    }

    this.orgSelected = this.activatedRoute.snapshot.queryParamMap.get(
      'organisationId'
    )
      ? Number(this.activatedRoute.snapshot.queryParamMap.get('organisationId'))
      : this.isAdmin
      ? 'all'
      : this.userOrgs[0].company_id;

    this.catSelected = this.activatedRoute.snapshot.queryParamMap.get(
      'categoryId'
    )
      ? Number(this.activatedRoute.snapshot.queryParamMap.get('categoryId'))
      : 'all';

    this.toggleVal = this.activatedRoute.snapshot.queryParamMap.get('type')
      ? this.activatedRoute.snapshot.queryParamMap.get('type')
      : 'all';

    this.DataSource = new ListingDataSource(this.ListingApi, 'listing-admin', {
      categoryId: this.catSelected,
      organisationId: this.orgSelected,
      status: this.status,
      type: this.toggleVal,
    });

    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe((Listings) => {
        this.Listings = Listings;
      })
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (PageEvent) => (this.PageEvent = PageEvent)
      )
    );

    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public addListing() {
    const DialogConfig = new MatDialogConfig();
    const data = new OrganisationDataSource(
      'listing-admin',
      this.OrganisationAdminApi
    );
    DialogConfig.disableClose = true;
    DialogConfig.data = data;

    if (this.isBranchAdmin) {
      const branchDataSource = new BranchDataSource(
        this.BranchApiService,
        'listing-admin'
      );

      DialogConfig.data = branchDataSource;

      this.dialog
        .open(BranchEventPicker, DialogConfig)
        .afterClosed()
        .subscribe((branch) => {
          if (branch) {
            this.editListing({
              id: null,
              branch_id: branch.id,
              organisation_id: branch.organisation_id,
            });
          } else {
            DialogConfig.data = data;
            this.orgPicker(DialogConfig);
          }
        });
    } else {
      this.orgPicker(DialogConfig);
    }
  }

  public orgPicker(DialogConfig) {
    this.Subscriptions.push(
      this.dialog
        .open(OrganisationPicker, DialogConfig)
        .afterClosed()
        .subscribe((organisation) => {
          if (organisation) {
            this.editListing({
              id: null,
              organisation_id: organisation.id,
            });
          }
        })
    );
  }

  public deleteListing(Listing: IListing) {
    confirm('Are you sure you want to delete: ' + Listing.title) &&
      this.DataSource.delete(Listing);
  }

  public setType(type: string) {
    this.DataSource.setFilter('type', type);
    return type;
  }

  public setStatus(status: string) {
    this.DataSource.setFilter('status', status);
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  public setOrgFilter(orgId) {
    const params = { ...this.activatedRoute.snapshot.queryParams };
    delete params['organisationId'];
    this.router.navigate([], { queryParams: params });
    this.DataSource.setFilter('organisationId', orgId);
    return Number(orgId);
  }

  public setCatFilter(catId) {
    const params = { ...this.activatedRoute.snapshot.queryParams };
    delete params['categoryId'];
    this.router.navigate([], { queryParams: params });
    this.DataSource.setFilter('categoryId', catId);

    return Number(catId);
  }

  public getOffers(Listing) {
    const config = new MatDialogConfig();
    config.data = {
      listingId: Listing.id,
      listingTitle: Listing.title,
      orgId: Listing.company_id,
      companyName: Listing.company_name || null,
    };

    return this.dialog
      .open(OffersList, config)
      .afterClosed()
      .subscribe(() => this.refreshListOfOne(Listing));
  }

  public getRelatedContent(Listing) {
    const config = new MatDialogConfig();
    config.data = {
      listingId: Listing.id,
      listingTitle: Listing.title,
    };
    return this.dialog.open(RelatedContentList, config).afterClosed();
  }

  public duplicateListing(Listing) {
    const duplicateListing = { ...Listing };
    duplicateListing.copiedId = Listing.id;
    delete duplicateListing.id;
    delete duplicateListing.variants;
    delete duplicateListing.slug;
    delete duplicateListing.company_name;

    this.DataSource.duplicate(duplicateListing).then(() =>
      this.refreshListOfOne(duplicateListing)
    );
  }

  public enableListing(Listing: IListing) {
    const enabled = !Listing.enabled;
    this.processListingId = Listing.id;

    this.DataSource.enable(Listing, enabled).then(
      () => (this.processListingId = 0)
    );
  }

  public editListing(Listing) {
    this.setImageCarousel(Listing);
    const config = new MatDialogConfig();
    const data: IEditListingConfig = {
      organisationId: Listing.organisation_id,
      branchId: Listing.branch_id,
      Listing: Listing.id ? Listing : null,
      DataSource: this.DataSource,
      CarouselImageDataSource: Listing.id ? this.CarouselImageDataSource : null,
    };
    config.disableClose = true;
    config.data = data;
    this.dialog
      .open(ListingEdit, config)
      .afterClosed()
      .subscribe((newListing?: IListing) => {
        this.CarouselImageDataSource = undefined;
        !!newListing && this.refreshListOfOne(newListing);
      });
  }

  public listAuditLog(Listing: IListing) {
    const config = new MatDialogConfig();
    config.data = {
      listingId: Listing.id,
      listingName: Listing.title,
      dataSource: this.DataSource,
    };
    this.dialog.open(AuditLog, config);
  }

  public listProductInfo(Listing: IListing) {
    const ProductInfoDataSource = this.ProductInfoApi.getDataSource(
      this.getDataSourceConfig(Listing)
    );

    this.Subscriptions.push(
      ProductInfoDataSource.list()
        .afterClosed()
        .subscribe(() => ProductInfoDataSource.disconnect())
    );
  }

  public listCohorts(Listing: IListing) {
    this.CohortsDataSource = new CohortsDataSource(
      this.CohortsApi,
      'listing-admin',
      'listing',
      Listing.id
    );
    const config = new MatDialogConfig();
    config.data = this.CohortsDataSource;
    config.disableClose = true;
    return this.dialog
      .open(CohortsList, config)
      .afterClosed()
      .subscribe(() => this.DataSource.loadWithPageEvent());
  }

  public listCategories(Listing: IListing) {
    this.CategoryDataSource = new CategoryDataSource(
      this.CategoryApi,
      'listing-admin',
      Listing.id
    );
    const config = new MatDialogConfig();
    config.data = this.CategoryDataSource;
    config.disableClose = true;
    return this.dialog
      .open(CategoriesList, config)
      .afterClosed()
      .subscribe(() => this.DataSource.loadWithPageEvent());
  }

  public listTickets(Listing: IListing) {
    const config = new MatDialogConfig();

    config.data = {
      listingId: Listing.id,
      listingTitle: Listing.title,
      companyId: Listing.company_id,
    };

    return this.dialog
      .open(TicketsList, config)
      .afterClosed()
      .subscribe(() => this.refreshListOfOne(Listing));
  }

  public listProducts(Listing: IListing) {
    const config = new MatDialogConfig();

    config.data = {
      listingId: Listing.id,
      listingTitle: Listing.title,
    };

    return this.dialog
      .open(ProductList, config)
      .afterClosed()
      .subscribe(() => this.refreshListOfOne(Listing));
  }

  public listCarousel(Listing: IListing) {
    this.setImageCarousel(Listing);
    this.CarouselImageDataSource.viewList('listing-admin');
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  private setImageCarousel(Listing: IListing) {
    this.CarouselImageDataSource = this.CarouselImageApi.getDataSource(
      this.getDataSourceConfig(Listing)
    );

    this.CarouselImageDataSource.load();
  }

  private getDataSourceConfig(Listing: IListing) {
    return {
      role: 'listing-admin',
      organisationId: Listing.company_id,
      listingId: Listing.id,
    };
  }

  private refreshListOfOne(Listing: IListing) {
    this.DataSource.setFilters([
      { filter: 'status', value: 'null' },
      { filter: 'searchString', value: Listing.title },
    ]);
    this.SearchComponent.setSearch(Listing.title);
  }

  public hasPermisson(group) {
    return this.Auth.inGroup(group);
  }

  public copyLink(listing) {
    this.clipboard.copy(
      environment.leisureUrl +
        '/' +
        ((listing.features['ballot'] && 'ballot') || 'listing') +
        '/' +
        listing.id +
        '/' +
        listing.slug
    );
  }

  public async createPreviewLink(listing: any) {
    let link = `${environment.leisureUrl}/listing/${listing.id}/${listing.slug}`;
    let apiToken: string | null = null;

    try {
      const exchangeResponse = await this.Auth.exchangePreviewTokens();

      apiToken = exchangeResponse?.token ?? null;
    } catch {
      // Fall back to preview-only link when token exchange fails.
    }

    if (!listing.enabled) {
      const username = `${this.Auth.user.firstName} ${this.Auth.user.lastName}`;
      const hashed = md5(JSON.stringify({ name: username, id: listing.id }));
      link += `${link.includes('?') ? '&' : '?'}preview=${hashed}`;
    }

    const fragmentParams = new URLSearchParams();
    if (apiToken) {
      fragmentParams.set('apiToken', apiToken);
    }

    const fragment = fragmentParams.toString();
    if (fragment) {
      link += `#${fragment}`;
    }

    window.open(link, '_blank');
  }

  public createTempUrl(listing: any) {
    const hash = md5(
      JSON.stringify({
        id: listing.id,
        name: listing.slug,
      })
    );
    let link = `${environment.leisureUrl}/listing/${listing.id}/${listing.slug}?temp=${hash}`;
    this.clipboard.copy(link);
  }
}
